import { useAuth } from '../context/AuthContext';

/**
 * useWalletRole — Phase 38
 * ------------------------------------------------------------------
 * Encapsulates the four Wallet visibility states derived from the
 * flags already present on the authenticated user object. Kept as a
 * single source of truth so every consumer (WalletPage, WalletLedger,
 * BuyerOnboardingCard, EarningsDashboard, ...) reads the same logic.
 *
 *   Admin       — Nymia staff.                       Sees everything.
 *   Creator     — Stripe Express verified.           Sees full creator UI.
 *   Onboarding  — has a Stripe Connect account but   Sees CTA + buyer UI.
 *                 payouts not yet enabled.
 *   Buyer       — nessun ruolo creator.              Sees only the buyer wallet.
 *
 * The flags are:
 *   - user.is_admin           → boolean
 *   - user.is_payout_ready    → Stripe Express verified creator
 *   - user.stripe_connect_id  → Stripe Connect account started
 *   - user.monetization_enabled  → per-account kill switch
 */
export const useWalletRole = () => {
  const { user } = useAuth();

  const isAdmin = user?.is_admin === true;
  // Phase 90 — VIP status decoupled from Stripe: derived on the backend
  // from creator_status === 'active' + monetization_enabled.
  const isCreatorReady = !!user?.is_verified_creator;
  const isInOnboarding =
    !isAdmin && !isCreatorReady && !!user?.stripe_connect_id;
  const isBuyerOnly = !isAdmin && !isCreatorReady && !isInOnboarding;

  return {
    isAdmin,
    isCreatorReady,
    isInOnboarding,
    isBuyerOnly,
    // Convenience flag: whether the user should see the *rich* wallet
    // (KPI in €, EarningsDashboard, Payout button, full ledger filters).
    showCreatorSurface: isAdmin || isCreatorReady,
  };
};

export default useWalletRole;
